import React from 'react';
import { 
  FaAward, 
  FaNetworkWired, 
  FaUserFriends, 
  FaHeadset,
  FaShieldAlt,
  FaRocket,
  FaChartLine,
  FaHandHoldingHeart,
  FaStar,
  FaCheckCircle
} from 'react-icons/fa';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const advantages = [
    {
      icon: <FaAward />,
      title: 'Expertise et fiabilité',
      description: 'Plus de 5 ans d\'expérience dans l\'accompagnement des étudiants internationaux. Notre expertise est reconnue par nos partenaires et nos étudiants.',
      stats: '5+ années d\'expérience',
      color: '#073b8f'
    },
    {
      icon: <FaNetworkWired />,
      title: 'Réseau d\'écoles partenaires',
      description: 'Accès exclusif à un large réseau d\'établissements d\'enseignement supérieur en France, des grandes écoles aux universités renommées.',
      stats: '50+ établissements partenaires',
      color: '#c0264a'
    },
    {
      icon: <FaUserFriends />,
      title: 'Accompagnement personnalisé',
      description: 'Un conseiller dédié vous suit tout au long de votre projet, avec un suivi individualisé adapté à votre profil et vos objectifs.',
      stats: 'Suivi 100% personnalisé',
      color: '#073b8f'
    },
    {
      icon: <FaHeadset />,
      title: 'Suivi jusqu\'à l\'installation',
      description: 'Nous ne vous lâchons pas ! Accompagnement complet jusqu\'à votre installation en France, y compris les démarches administratives sur place.',
      stats: 'Accompagnement complet',
      color: '#c0264a'
    }
  ];

  const additionalBenefits = [
    {
      icon: <FaShieldAlt />,
      title: 'Sécurité et transparence',
      description: 'Processus clairs, coûts transparents et garantie de services conformes aux réglementations françaises.',
      color: '#073b8f'
    },
    {
      icon: <FaRocket />,
      title: 'Gain de temps optimal',
      description: 'Optimisation de toutes les démarches administratives pour un processus rapide et efficace.',
      color: '#c0264a'
    },
    {
      icon: <FaChartLine />,
      title: 'Taux de réussite élevé',
      description: '95% de nos étudiants obtiennent leur visa et intègrent l\'établissement de leur choix.',
      color: '#073b8f'
    },
    {
      icon: <FaHandHoldingHeart />,
      title: 'Support dédié 24/7',
      description: 'Une équipe à votre écoute pour répondre à toutes vos questions et préoccupations.',
      color: '#c0264a'
    }
  ];

  const successMetrics = [
    { number: '95%', label: 'Taux de réussite visa' },
    { number: '1000+', label: 'Étudiants accompagnés' },
    { number: '48h', label: 'Réponse moyenne' },
    { number: '98%', label: 'Satisfaction étudiants' }
  ];

  return (
    <section className="btg-why-choose-us-dark" id="btg-why-choose">
      <div className="btg-container-dark">
        {/* En-tête de section - Style sombre premium */}
        <div className="btg-why-header-dark">
          <div className="btg-header-content-dark">
            <div className="btg-header-badge">
              <FaStar className="btg-badge-icon" />
              <span>Excellence & Confiance</span>
            </div>
            <h1 className="btg-main-title-dark">Pourquoi choisir BTG CONSEIL ?</h1>
            <p className="btg-main-subtitle-dark">Votre partenaire de confiance</p>
            <p className="btg-section-subtitle-dark">
              Découvrez les avantages qui font de nous le partenaire de confiance 
              pour votre projet d'études en France
            </p>
            <div className="btg-header-decoration-dark">
              <div className="btg-decoration-line-dark"></div>
              <div className="btg-decoration-dot-dark"></div>
              <div className="btg-decoration-glow-dark"></div>
              <div className="btg-decoration-dot-dark"></div>
              <div className="btg-decoration-line-dark"></div>
            </div>
          </div>
        </div>

        {/* Métriques de succès */}
        <div className="btg-success-metrics-dark">
          {successMetrics.map((metric, index) => (
            <div key={index} className="btg-metric-card-dark">
              <div className="btg-metric-number-dark">{metric.number}</div>
              <div className="btg-metric-label-dark">{metric.label}</div>
              <div className="btg-metric-glow"></div>
            </div>
          ))}
        </div>

        {/* Avantages principaux */}
        <div className="btg-advantages-grid-dark">
          {advantages.map((advantage, index) => (
            <div 
              key={index} 
              className="btg-advantage-card-dark"
              style={{ '--btg-accent-color': advantage.color }}
            >
              <div className="btg-card-glow" style={{ '--glow-color': advantage.color }}></div>
              
              <div className="btg-advantage-icon-wrapper-dark">
                <div className="btg-advantage-icon-dark">
                  {advantage.icon}
                </div>
                <div className="btg-icon-glow"></div>
              </div>
              
              <div className="btg-advantage-content-dark">
                <h3>{advantage.title}</h3>
                <p>{advantage.description}</p>
                <div className="btg-advantage-stats-dark">
                  <FaCheckCircle className="btg-stat-icon" />
                  {advantage.stats}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bannière de valeur */}
        <div className="btg-value-banner-dark">
          <div className="btg-value-content-dark">
            <div className="btg-value-text-dark">
              <h3>Notre engagement : Votre réussite</h3>
              <p>
                Chez BTG CONSEIL, nous croyons que chaque étudiant mérite une chance 
                de réussir son projet d'études à l'étranger. Notre mission va au-delà 
                des simples formalités administratives : nous vous accompagnons vers 
                une intégration réussie en France.
              </p>
            </div>
            <div className="btg-value-badge-dark">
              <FaHandHoldingHeart className="btg-badge-icon" />
              <span>Engagement total</span>
            </div>
          </div>
          
          {/* Background animé */}
          <div className="btg-banner-background-dark">
            <div className="btg-banner-particle"></div>
            <div className="btg-banner-particle"></div>
            <div className="btg-banner-particle"></div>
          </div>
        </div>

        {/* Avantages supplémentaires */}
        <div className="btg-additional-benefits-dark">
          <div className="btg-benefits-header-dark">
            <div className="btg-benefits-header-content-dark">
              <h2 className="btg-benefits-main-title-dark">Nos engagements supplémentaires</h2>
              <p className="btg-benefits-subtitle-dark">Excellence et qualité de service</p>
              <div className="btg-benefits-header-decoration-dark">
                <div className="btg-benefits-decoration-line-dark"></div>
                <div className="btg-benefits-decoration-dot-dark"></div>
                <div className="btg-benefits-decoration-line-dark"></div>
              </div>
            </div>
          </div>
          
          <div className="btg-benefits-grid-dark">
            {additionalBenefits.map((benefit, index) => (
              <div 
                key={index} 
                className="btg-benefit-card-dark"
                style={{ '--btg-accent-color': benefit.color }}
              >
                <div className="btg-benefit-icon-container-dark">
                  <div className="btg-benefit-icon-dark">
                    {benefit.icon}
                  </div>
                  <div className="btg-icon-glow"></div>
                </div>
                <div className="btg-benefit-content-dark">
                  <h4>{benefit.title}</h4>
                  <p>{benefit.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Final */}
        <div className="btg-final-cta-dark">
          <div className="btg-cta-content-dark">
            <div className="btg-cta-header-dark">
              <h3 className="btg-cta-title-dark">Prêt à démarrer votre aventure ?</h3>
              <p className="btg-cta-subtitle-dark">Votre réussite commence ici</p>
            </div>
            <p className="btg-cta-text-dark">
              Rejoignez les centaines d'étudiants qui nous font confiance 
              pour concrétiser leur projet d'études en France
            </p>
            <div className="btg-cta-buttons-dark">
              <button className="btg-cta-primary-dark">
                <FaRocket className="btg-cta-icon" />
                Commencer mon projet
                <div className="btg-button-glow"></div>
              </button>
              <button className="btg-cta-secondary-dark">
                Poser une question
              </button>
            </div>
            
            <div className="btg-cta-stats-dark">
              <div className="btg-stat-dark">
                <div className="btg-stat-number-dark">500+</div>
                <div className="btg-stat-label-dark">Étudiants accompagnés</div>
              </div>
              <div className="btg-stat-dark">
                <div className="btg-stat-number-dark">95%</div>
                <div className="btg-stat-label-dark">Taux de réussite</div>
              </div>
              <div className="btg-stat-dark">
                <div className="btg-stat-number-dark">98%</div>
                <div className="btg-stat-label-dark">Satisfaction</div>
              </div>
            </div>
          </div>
          
          {/* Background animé */}
          <div className="btg-cta-background-dark">
            <div className="btg-cta-particle"></div>
            <div className="btg-cta-particle"></div>
            <div className="btg-cta-particle"></div>
          </div>
        </div>
      </div>

      {/* Background éléments décoratifs */}
      <div className="btg-background-elements">
        <div className="btg-bg-element btg-bg-1"></div>
        <div className="btg-bg-element btg-bg-2"></div>
        <div className="btg-bg-element btg-bg-3"></div>
        <div className="btg-bg-element btg-bg-4"></div>
      </div>
    </section>
  );
};

export default WhyChooseUs;